













































































import Enumerable from "linq";
import { Component, Mixins, Prop } from "vue-property-decorator";
import { ReceptionDetail, ReceptionManager, ReceptionProofPeriod } from "../../../../domain/workflow/reception";
import { WorkflowPhaseEditorModel } from "../../../../domain/workflow/editor";
import { WorkflowCommonMixin } from "../../mixins";

@Component({
  components: {}
})
export default class ReceptionDetailView extends Mixins(WorkflowCommonMixin) {
  @Prop()
  detail: ReceptionDetail;

  @Prop()
  isProjectTeamVisible: boolean;

  @Prop()
  isPaperNameVisible: boolean;

  @Prop()
  isPaperCompanyNameVisible: boolean;

  @Prop()
  isDiseaseVisible: boolean;

  get companyName(): string {
    return (this.isPaperCompanyNameVisible && this.detail && this.detail.paperCompanyName)
      ? this.detail.paperCompanyName
      : ((this.detail && this.detail.format && this.detail.format.company) ? this.detail.format.company.name : "");
  }

  get formatName(): string {
    return this.detail && this.detail.format ? this.detail.format.name : "";
  }

  get paperName(): string {
    return this.detail ? this.detail.paperName : "";
  }

  get projectTeamName(): string {
    return this.detail && this.detail.projectTeam ? this.detail.projectTeam.name : "";
  }

  get departmentName(): string {
    return this.detail && this.detail.department ? this.detail.department.name : "";
  }

  get managers(): ReceptionManager[] {
    return this.detail && this.detail.managers ? this.detail.managers : [];
  }

  get managerNames(): string {
    const names = Enumerable.from(this.managers)
      .select(m => !!m.staff.phone ? m.staff.name + "（" + m.staff.phone + "）" : m.staff.name)
      .toArray();
    return names.join("・");
  }

  get progressCondition(): string {
    return this.detail && this.detail.route ? this.detail.route.progressConditionName : "";
  }

  get disease(): string {
    return this.detail ? this.detail.disease : "";
  }

  get proofPeriods(): ReceptionProofPeriod[] {
    return this.detail && this.detail.proofPeriods ? this.detail.proofPeriods : [];
  }

  get phases(): WorkflowPhaseEditorModel[] {
    return this.detail && this.detail.route ? this.detail.route.phases : [];
  }
}
